// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"9b47c4faee2ae50f39b7","339":"b56fab9bb3661146be49"}[chunkId] + ".js";
};